const white = '#ffffff';
const blurple = '#5866ef';
const onlineGreen = '#3da560';
const idleYellow = '#f9a62b';
const dndRed = '#ec4145';
const braveryPurple = '#9b84ec';
const brillianceCoral = '#f37b68';
const balanceTurqoise = '#49ddc1';
const nitroGrey = '#4f5d7e';
const boostPink = '#fe73f6';
const streamerPurple = '#583694';
const hyperlinkBlue = '#09b0f2';
const sylemsBlue = '#0f66dc';
const darkGrey = '#2f3136';
const black = '#000000';

const vsBlue = '#007acc';
const vsGray = '#3e3e42';
const vsDarkGray = '#2d2d30';
const vsAlmostBlack = '#252526';
const vsBlack = '#1e1e1e';
const draculaBlack = '#282a36';

export default {
  white,
  blurple,
  onlineGreen,
  idleYellow,
  dndRed,
  braveryPurple,
  brillianceCoral,
  balanceTurqoise,
  nitroGrey,
  boostPink,
  streamerPurple,
  hyperlinkBlue,
  sylemsBlue,
  darkGrey,
  black,
  vsBlue,
  vsGray,
  vsDarkGray,
  vsAlmostBlack,
  vsBlack,
  draculaBlack
};
